module.exports = __webpack_public_path__ + "static/media/envelope_gray.df116cbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/envelope_gray.svg
// module id = 1434
// module chunks = 47